import { Box, Group, Text } from '@mantine/core';

interface Props {
  name?: string | null;
  color?: string | null;
  clientName?: string | null;
  taskName?: string | null;
  size?: 'xs' | 'sm' | 'md';
  placeholder?: string;
}

/** Projekt mit farbigem Punkt (Projektfarbe), optional Task und Client. */
export function ProjectDot({ name, color, clientName, taskName, size = 'sm', placeholder }: Props) {
  if (!name) {
    return placeholder ? (
      <Text size={size} c="dimmed">
        {placeholder}
      </Text>
    ) : null;
  }
  return (
    <Group gap={6} wrap="nowrap" style={{ minWidth: 0 }}>
      <Box w={8} h={8} style={{ borderRadius: '50%', background: color ?? 'var(--mantine-color-gray-5)', flexShrink: 0 }} />
      <Text size={size} c={color ?? undefined} fw={500} truncate>
        {name}
        {taskName ? `: ${taskName}` : ''}
      </Text>
      {clientName && (
        <Text size={size} c="dimmed" truncate>
          – {clientName}
        </Text>
      )}
    </Group>
  );
}
